import { Outlet, createFileRoute } from "@tanstack/react-router";

import { casesOriginCrumb } from "@/lib/crumb-resolvers";

// 注: ロールガードは親 layout (`admin/route.tsx`) が ADMIN 限定。
// crumb は出自 (`?from=`) に応じて 承認待ち案件 / 全案件管理 / 応募管理 を切り替える。
// 一覧 (`/admin/cases` 自身) は L1 なので breadcrumb 非表示、分岐結果は詳細ページでのみ効く。
export const Route = createFileRoute("/_authenticated/admin/cases")({
  staticData: { crumb: casesOriginCrumb() },
  component: () => <Outlet />,
});
